<div *ngIf="display" class="overlay">
  <button class="close-btn" (click)="closeOverlay()">&times;</button>
  <div class="carousel-overlay-content">
    <p-carousel
      [value]="images"
      [page]="page"
      [showIndicators]="showIndicators"
      [showNavigators]="showNavigators"
      [circular]="circular"
      [autoplayInterval]="autoplayInterval"
      [orientation]="orientation"
      (onPage)="onCarouselPageChange($event)"
    >
      <ng-template let-image pTemplate="item">
          <img 
            appDisableRightClick 
            appMobileOptimization
            [originalUrl]="image?.url"
            [src]="image?.url" 
            [format]="'webp'"
            class="carousel-image"
            alt="Carousel Image"
            loading="lazy"
            decoding="async"
          />
      </ng-template>
    </p-carousel>
  </div>
</div>
